// 配送方法
export const DeliveryMethods = Object.freeze({
  YOUPACK: 1,
  DIRECT: 2,
});

// 支払方法
export const PaymentMethods = Object.freeze({
  CREDIT: 1,
  TRANSFER: 2,
  CASH: 3,
});

// 販売媒体
export const SalesMedia = Object.freeze({
  SALES_APP: 1,
  BASE: 2,
});

// 注文ステータス
export const OrderStatuses = Object.freeze({
  ORDER: 10,
  SHIPPING: 20,
  COMPLETE: 30,
});

// HTTPエラーステータス
export const HttpStatuses = Object.freeze({
  BAD_REQUEST: '400',
  UNAUTHORIZED: '401',
  NOT_FOUND: '404',
  CONFLICT: '409',
  INTERNAL_SERVER_ERROR: '500',
});
